import { useEffect, useState } from 'react';

interface IProps {
  remainingTime: number;
  gameState: number;
}

const DJackGameCountdown: React.FC<IProps> = ({
  remainingTime,
  gameState
}: IProps) => {
  const [remainingSeconds, setRemainingSeconds] = useState(remainingTime);

  useEffect(() => {
    setRemainingSeconds(remainingTime);
    const interval = setInterval(() => {
      if (gameState === 2 && remainingTime > 0) {
        setRemainingSeconds((r) => r - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [remainingTime, gameState]);

  return <div>{remainingSeconds}</div>;
};

export default DJackGameCountdown;
